export default "  <ion-avatar class=\"custom-avatar\" *ngIf=\"avatar$ | async \">\n    <img [src]=\"avatar\" />\n  </ion-avatar>\n       "